var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Info = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 28 28", width: "100%", height: "100%" }, props),
        React.createElement("path", { d: "M14 28C6.268 28 0 21.732 0 14S6.268 0 14 0s14 6.268 14 14-6.268 14-14 14zm-1.736-11.916c0 .78.312 1.508 1.014 2.106l1.586-.676c-.442-.338-.702-.858-.702-1.274 0-1.144 1.014-1.82 2.132-2.6 1.378-.962 2.912-2.028 2.912-4.212 0-2.236-1.924-4.03-5.096-4.03-2.47 0-4.394 1.04-5.642 2.652l1.3 1.404c.962-1.274 2.184-2.132 4.134-2.132 2.054 0 3.068 1.118 3.068 2.418 0 1.326-1.066 2.054-2.21 2.834-1.196.858-2.496 1.768-2.496 3.51zm.13 5.746c0 .78.65 1.43 1.43 1.43.78 0 1.43-.65 1.43-1.43 0-.78-.65-1.43-1.43-1.43-.78 0-1.43.65-1.43 1.43z", fill: color })));
};
Info.defaultProps = {
    color: '#333',
};
export default Info;
//# sourceMappingURL=Info.js.map